import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ShowregisterloginService {

  public hr_registrationSubject = new Subject<any>();

  // public calenderSubject = new Subject<any>();



  constructor() { }

  showPage(data) {
    this.hr_registrationSubject.next(data);

  }

  dayClicked(data) {
    this.hr_registrationSubject.next(data);
  }


}
